// Batch 6A — Outcome Measurement modes for prompt-level templates.
// Backed by prompt_level_templates.outcomeMode enum.
//
// T63 Part C §4 — `rating_scale` retired from the offered set.
// Backend recorder has no branch on it and prompt_levels has no
// rating-scale-specific column, so it saved as a no-op that
// silently degraded to Successful/Unsuccessful at score time.
// Legacy rows persisted with rating_scale still render (see
// LEGACY_ONLY below) so the editor doesn't blank out an existing
// selection, but the picker only offers the two working modes.

export type OutcomeMode = "successful_unsuccessful" | "weighted";
export type OutcomeModeLegacy = OutcomeMode | "rating_scale";

export const DEFAULT_OUTCOME_MODE: OutcomeMode = "successful_unsuccessful";

// Order here drives the order in the Outcome Measurement submenu.
export const OUTCOME_MODE_LABELS: Record<OutcomeMode, string> = {
  successful_unsuccessful: "Successful / Unsuccessful",
  weighted:                "Weighted",
};

// Labels for legacy values still on disk — display-only.
export const LEGACY_OUTCOME_MODE_LABELS: Record<string, string> = {
  rating_scale: "Rating Scale (retired)",
};

export function isOutcomeMode(v: unknown): v is OutcomeMode {
  return v === "successful_unsuccessful" || v === "weighted";
}

export function normaliseOutcomeMode(raw: unknown): OutcomeMode {
  return isOutcomeMode(raw) ? raw : DEFAULT_OUTCOME_MODE;
}
